import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { makeStyles } from "@material-ui/core";
import { Colors } from "styles/Colors";

const useStyles = makeStyles(() => ({
	dark: {
		backgroundColor: Colors.panel,
		color: Colors.primary,
		"& .MuiDataGrid-cell": { color: Colors.primary },
		"& .MuiDataGrid-columnHeaderTitle": { color: Colors.primary },
		"& .MuiTablePagination-root, & .MuiTablePagination-displayedRows, & .MuiTablePagination-selectIcon, & .MuiTablePagination-actions button":
			{ color: Colors.primary },
		"& .MuiTablePagination-actions button:disabled": {
			color: Colors.panelLighterColor,
		},
		"& .MuiDataGrid-menuIconButton, & .MuiDataGrid-sortIcon": {
			color: Colors.primary,
		},
		"& .MuiDataGrid-row:hover": {
			backgroundColor: `${Colors.panelLight}!important`,
		},
		"&.MuiDataGrid-root .MuiDataGrid-cell:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus-within, &.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within":
			{ outline: "none" },
	},
}));

const cx = (...classNames) => classNames.filter(Boolean).join(" ");

export default function DarkDataGrid({ className, ...props }) {
	const styles = useStyles();
	return <DataGrid className={cx(styles.dark, className)} {...props} />;
}
